import React, { useEffect, useState } from 'react';
import { Button, Modal, Table } from 'antd';
import 'antd/dist/reset.css';  // Ensure Ant Design styles are imported
// import '../../App.css';  // Import custom styles
import { DatePicker } from 'antd'; 
import dayjs from 'dayjs'; 
import { getAdjustedDate } from '../CommonFunctions';
import { useStoreUpdaterWithAPI } from '../../../Hooks/UseStoreUpdaterWithApi';
import { adjustTimeByFiveHoursThirtyMinutes, calculateDateRangeFromDate } from '../../../Utils/DateConverstion';
import { APIConstants } from '../../../Common/APIConstants';
import { TransformHTDataToDataTable } from '../chartdata.transformers';



const { RangePicker } = DatePicker;  
 
export default function SensorDataTable(props) {
  const isDataPresent = props.data && props.data.length > 0;
  const theme = props.theme;  
  // const data = props.data;
  const [data, setData]= useState([]);
  const {makeRequest} = useStoreUpdaterWithAPI();
  const correctDate =  new Date(getAdjustedDate()); 
  // console.log(correctDate);
 
  // console.log(getAdjustedDate().toDateString());

  // Default start time: Today 6:30 AM, Default end time: Tomorrow 6:30 AM
  const defaultStartTime = dayjs(correctDate).hour(6).minute(30).second(0);
  const defaultEndTime = dayjs(correctDate).add(1, 'day').hour(6).minute(30).second(0);
  // console.log(defaultStartTime); 

  const [toDate, setToDate] = useState(defaultEndTime);
  const [fromDate, setFromDate] = useState(defaultStartTime);
  // console.log(fromDate);

  const onRangeChange = (dates, dateStrings) => { 
    console.log('Date strings:', dateStrings);
    // console.log('Dates:', dates);
    if (dates) {
      setToDate(new Date(dateStrings[0]));
      setFromDate(new Date(dateStrings[1]));
    } else {
      console.log('Clear');
    }
  };

  const rangePresets = [
    {
      label: 'Last 7 Days',
      value: [dayjs().add(-7, 'd'), dayjs()],
    },
    {
      label: 'Last 14 Days',
      value: [dayjs().add(-14, 'd'), dayjs()],
    },
    {
      label: 'Last 30 Days',
      value: [dayjs().add(-30, 'd'), dayjs()],
    },
    {
      label: 'Last 90 Days',
      value: [dayjs().add(-90, 'd'), dayjs()],
    },
  ];
  
  console.log(data)
  // [
  //   {
  //     meterName: 'MAIN EB INCOMER',
  //     kwt: 526, 
  //     vllAvg: 404,
  //     status: 'Active'
  //   }
  // ]
  const columnKeys = data.length>0 && Object.keys(data[0]);
  const headers = data.length>0 && columnKeys.map(columnKey => ({
    title: columnKey==='kwt'? 'kw'.toUpperCase():columnKey.toUpperCase(),
    dataIndex: columnKey,
    key: columnKey,
    render: columnKey === 'status' ? renderStatusTag : undefined
  }));

  function renderStatusTag(status) {
    const statusClass = status === 'Active' ? 'status-tag-active' : 'status-tag-inactive';
    return <span className={`status-tag ${statusClass}`}>{status}</span>;
  } 

  const getReposnse =()=>{
    // setLoading(true)
    const currentDate = new Date(); 
  
    const { from, to } = calculateDateRangeFromDate(currentDate,5,2);
  
    const inputData = { 
      FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),  
      ToDate:adjustTimeByFiveHoursThirtyMinutes(toDate),
    }; 
    console.log('getReposnse')
    console.log(inputData.ToDate)
    console.log(inputData.FromDate)
  
   
    try {      
      makeRequest({
        type: APIConstants.GET,
        url:`${APIConstants.LUCAS_LIVE_DATA_TABLE}?FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`
        // url:`${APIConstants.LUCAS_LIVE_GAUGE}?FromDate=2024%2F08%2F13%2006%3A30%3A00&ToDate=2024%2F08%2F13%2006%3A30%3A00`
      }).then((res) => {   
        console.log('response' )
        console.log(res)      
        if(res&& res.length > 0) {
          console.log(TransformHTDataToDataTable(res)) 
          setData(TransformHTDataToDataTable(res)) 
        }
        
  
      });      
    } catch (error) {
      // setError(true);  
      console.log(error);
    }      
  
  }    

  console.log(data)

  useEffect(() => {
    getReposnse(); // Initial fetch

    const intervalId = setInterval(() => {
      getReposnse();
    }, 60000); // 60000 milliseconds = 1 minute

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);
  
 
  return (
    <div className={`overflow-hidden overflow-x-scroll shadow-2xl w-full h-full  no-Scroll  ${theme === 'dark' ? 'bg-blue-900' : 'bg-[#fff]'}`}>
      {data &&  data.length > 0? (
        
        <div className=''>
          <div className={`${theme === 'dark' ? 'text-white' : 'text-slate-700 bg-[#99d9ea]'}  flex  text-xl font-bold px-4 p-2  w-full`}>
          Status
          </div> 
          <Table
            dataSource={data} 
            columns={headers}
            pagination={false}
            className={`${theme} h-[350px] custom-table flex-grow ${theme === 'dark' ? 'custom-table-dark' : 'custom-table-light'}`}
            bordered={false}
          />
          {/* <div className="flex justify-center items-center w-full">
                <p className='bg-transparent w-fit p-2 py-3 mb-2 text-white  bottom-0' >
                  <RangePicker
                    presets={[
                      {
                        label: <span aria-label="Current Time to End of Day">Now ~ EOD</span>,
                        value: () => [dayjs(), dayjs().endOf('day')],
                      },
                      ...rangePresets,
                    ]}
                    showTime
                    format="YYYY/MM/DD HH:mm:ss"
                    defaultValue={[fromDate, toDate]}
                    className={`customRangePicker   ${theme === 'dark' ? 'customRangePicker-dark' : 'customRangePicker-light'}`}
                    onChange={onRangeChange}
                    open={false}
                    disabled={[true, true]}
                  />
                </p>
          </div>  */}
        </div>
      ) : (
        <Table className="w-full" />
      )}

    </div>
  );
}
